import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';

export interface Notification {
  message: string;
  icon: string;
  verticalAlign: string;
  horizontalAlign: string;
  type: string;
  timeout: number;
  timestamp: Date;
}

export interface State {
  display: Notification[];
}

const defaultState: State = {
  display: [],
};

const getters = {
};

const mutations: MutationTree<State> = {

  add(state: State, notification: Notification) {
    notification.timestamp = new Date();
    notification.timestamp.setMilliseconds(
      notification.timestamp.getMilliseconds() + state.display.length
    );
    state.display.push(notification);
  },

  remove(state: State, timestamp: Date) {
    state.display = state.display.filter(
      (n: Notification) => n.timestamp !== timestamp
    );
  },

};

const actions: ActionTree<State, RootState> = {

  notify({ commit, state }, notification: Notification | Notification[]) {

    if (!Array.isArray(notification))
      notification = [notification];

    notification.forEach((n: Notification) => {
      commit('add', n);
    });

  },

};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
